
import './index.less'
import Cpts002 from '@/components/lyx-components/cpts002/index.vue'
import Cpts020 from '@/components/public-components/loading/index.vue'
import Cpts029 from '@/components/public-components/collect/index.vue'

import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import util from '@/javascript/util'
import bus from '@/javascript/bus'
import EsQuery from '@/javascript/esQuery'
import Audio from './audio'
import goBack from '@/components/public-components/goBack/index.vue'
import Footer from "@/components/lyx-components/lyx-footer/index"

export default {
directives: {
TransferDom
},
computed: {
titleImage(){
if(this.strategy && this.strategy.titleImageUrl && this.strategy.titleImageUrl.includes('http')){
return this.strategy.titleImageUrl
}else{
return this.PIC_BASE_URL + this.strategy.titleImageUrl
}
}
},
components: {
Confirm,
Cpts002,
Cpts020,
Cpts029,
goBack,
Footer
},
data() {
return {
isWeixin: util.isWeiXin(),
isLogin: Boolean(bus.userInfo.access_token),
strategy: {},
catalogs: [],
catalog: {},
minHeight: 0,
content: '',
nextShow: true,
prevShow: true,
prevData: '',
nextData: '',
index_back: 0,
passWord: {
identiferId: '',
articleSite: '',
moduleCode: 6202,
collTypes: this.XQSC_TYPE_CODE.GL,
name: '',
appCode: 62
},
strategyEntity: {},
readTextStatus: false,

}
},
created() {
const pageSite = window.location.pathname + window.location.hash
if (pageSite.substring(pageSite.length - 2) == '-1') {
this.passWord.articleSite = pageSite.substring(0, pageSite.length - 5) + '/0/0'
} else {
this.passWord.articleSite = pageSite.substring(0, pageSite.length - 4) + '/0/0'
}
this.initData()




},
mounted() {
this.minHeight = document.documentElement.clientHeight
/**
* 页面滚动
*/
window.addEventListener('scroll', this.windowScroll);
},
methods: {
initData: function () {
/**
* 详情内容
*/
this.$http.get('/api/wtcp-traveltips/public/tips/findById/' + this.$route.params.id).then((response) => {
this.strategy = response.data.data.tipsEntity
this.catalogs = response.data.data.catalog

this.passWord.identiferId = response.data.data.tipsEntity.id
this.passWord.name = response.data.data.tipsEntity.title

const strategy = response.data.data.tipsEntity,
strategyEntity = {}

strategyEntity.titleImageUrl = strategy.titleImageUrl
strategyEntity.serviceType = 100
strategyEntity.summary = strategy.summary
strategyEntity.title = this.catalogs[0].title

this.$set(this, 'strategyEntity', strategyEntity)

this.catalogs.forEach((item, idx) => {
if (item.anchor.length > 0) {
this.$http.get('/api/wtcp-traveltips/public/notes/findById/' + item.anchor[0].noteId).then((response) => {
let content = response.data.data.notesEntity.content.replace(/\&nbsp;/g, "")
content = content.replace(/\anchorname=/g, "class=")
this.$set(item, 'content', content)
}).then(() => {
/**
* 关联资源
*/
const relationSource = document.getElementsByClassName('note-relate-info')
for (let i = 0; i < relationSource.length; i++) {
const businessEsQuery = new EsQuery()
businessEsQuery.addString("id", relationSource[i].getAttribute('data-id'), businessEsQuery.and, false)
.addString("issue", '1', businessEsQuery.or, false)
const businessEsJsonQuery = JSON.stringify(businessEsQuery.getArray())
this.$http.get('/bicQuery?esJsonQuery=' + encodeURI(businessEsJsonQuery)).then((response) => {
if (response.data.data.length > 0) {
const businessData = response.data.data[0]._source

let href = ''
if (businessData.bType == this.XXCJ_TYPE_CODE.JQ) {
href = '/webapp/#/scenic-view/' + businessData.id
} else {
href = '/webapp/#/business-view/' + businessData.bType + '/' + businessData.id
}
const html = '<a href="' + href + '">' +
'           <div class="relation-resources-box item-0' + i % 3 + '">' +
'                <div class="img-box" style="background-image: url(' + this.PIC_BASE_URL + businessData.titleImage + ')"></div>' +
'                <div class="info">' +
'                    <h1>' + businessData.name + '</h1>' +
'                    <p>' + businessData.address + '</p>' +
'                </div>' +
'            </div>' +
'           <a>'
relationSource[i].innerHTML = html
}
})
}


const contentBox = document.getElementsByClassName('content-box')
for (let i = 0; i < contentBox.length; i++) {
if (this.$route.params.idx2 != -1) {
const anchor = contentBox[i].getElementsByClassName('anchorname-note')
for (let j = 0; j < anchor.length; j++) {
if (i == this.$route.params.idx1 && j == this.$route.params.idx2) {
window.scrollTo(0, anchor[j].offsetTop - 20)
}
}
} else if (i == this.$route.params.idx1) {
if (i == 0) {
window.scrollTo(0, 0)
} else {
window.scrollTo(0, contentBox[i].offsetTop - 20)
}
}
}
})
}
})
}).then(() => {
document.title = this.strategy.title
/**
* 微信签名分享
*/
console.log(this.PIC_BASE_URL + this.strategy.titleImageUrl)
if (this.isWeixin) {
const shareData = typeof (shareData) === 'undefined' ? {
title: this.strategy.title,
desc: this.strategy.summary || '“大美盐龙灯，安居天下客”自贡大安欢迎您~',
imgUrl: this.strategy.titleImageUrl ? (this.PIC_BASE_URL + this.strategy.titleImageUrl) : window.location.origin + '/static/zg-img/banner_img.png',
link: window.location.href
} : shareData;

this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href) + '&appId=' + this.WX_APPID).then((response) => {
util.initWxConfig(response.data.data, shareData)
})
}
})

/**
* 访问量
*/
this.$http.get('/api/wtcp-traveltips/public/tips/click/' + this.$route.params.id)
},
onStatusChange: function (val1, val2) {
this.index_back = val1;
this.$router.replace('/strDesSelView/' + this.$route.params.id + '/' + val1 + '/' + val2)
this.initData()
},
readText() {
this.readTextStatus = !this.readTextStatus
if (this.readTextStatus) {
this.tts(document.getElementsByClassName('selected-view-container')[0].innerText.substring(0, 1000))
}
},
tts: function (e) {
const that = this


that.audio = Audio({
tex: e,
tok: that.tokData,
spd: 5,
pit: 5,
vol: 15,
per: 4
}, {
volume: 0.3,
autoDestory: true,
timeout: 10000,
hidden: true,
pauseAudio: false,
autoplay: "autoplay",
onInit: function (htmlAudioElement) {
},
onSuccess: function (e) {
this.baidYy = e
const audio = document.getElementById('baidYyPlay');
audio.setAttribute('src', this.baidYy);
document.addEventListener("WeixinJSBridgeReady", function () {
audio.play()
}, false)
if (audio.paused) {
audio.play()
}
},
onError: function (text) {
console.log(text)
},
onTimeout: function () {
console.log('timeout')
}
})
}
}
}
